import { render, staticRenderFns } from "./ExemptionOrderView.vue?vue&type=template&id=0a365d72&scoped=true"
import script from "./ExemptionOrderView.vue?vue&type=script&lang=ts"
export * from "./ExemptionOrderView.vue?vue&type=script&lang=ts"
import style0 from "./ExemptionOrderView.vue?vue&type=style&index=0&id=0a365d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a365d72",
  null
  
)

export default component.exports